export const FLAG_GETTING_SEAT_MAP_ELEMENTS = 'FLAG_GETTING_SEAT_MAP_ELEMENTS';
export const GET_SEAT_MAP_ELEMENTS = 'GET_SEAT_MAP_ELEMENTS';
export const CLEAR_SEAT_MAP_ELEMENTS = 'CLEAR_SEAT_MAP_ELEMENTS';
export const FLAG_GETTING_SEAT_MAP_ELEMENT = 'FLAG_GETTING_SEAT_MAP_ELEMENT';
export const GET_SEAT_MAP_ELEMENT = 'GET_SEAT_MAP_ELEMENT';
export const CLEAR_SEAT_MAP_ELEMENT = 'CLEAR_SEAT_MAP_ELEMENT';
